import { render, staticRenderFns } from "./Recorrencia.vue?vue&type=template&id=4fb07274"
import script from "./Recorrencia.vue?vue&type=script&lang=js"
export * from "./Recorrencia.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports